<template>
  <router-view :key="route.fullPath" />
</template>
<script>
import { useRoute } from 'vue-router'

export default {
  data() {
    return {
      route: useRoute(),
    }
  },
}
</script>
<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
.page {
  width: 100%;
  height: 100%;
}
.none {
  display: none;
}
.table-input-btn {
  padding: 0 10px;
  cursor: pointer;
}
.table-input-info {
  padding: 0 10px;
}
.form-item-label {
  line-height: 16px;
}
.el-button i {
  margin-right: 5px;
}
.el-table__cell {
  position: static !important;
}
:focus {
  outline: none;
}
.custom-tags {
  display: flex;
  gap: 10px;
  width: 100%;
}
.custom-table {
  width: 100%;
  border: 0;
  border-color: transparent;
  border-spacing: 0;
  border-collapse: collapse;
  &[border] {
    border-color: #eee;
  }
  thead {
    background-color: var(--el-fill-color-light);
    td {
      padding: 8px;
      box-sizing: border-box;
    }
  }
  tbody {
    tr {
      color: var(--el-text-color-regular);
      cursor: pointer;
      &:hover {
        background-color: var(--el-fill-color-light);
      }
      &.custom-active {
        color: var(--el-color-primary);
        background-color: var(--el-fill-color-light);
      }
      td {
        padding: 7px 8px;
        font-size: var(--el-font-size-base);
        box-sizing: border-box;
      }
    }
  }
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #f1f1f1;
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  background-color: #fff;
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #e2e2e2;
}
::-webkit-scrollbar-thumb:hover {
  border-radius: 5px;
  background-color: #c4c4c4;
}
</style>
